export default "__VITE_ASSET__S5sPimng__"